<template>
  <div style="position: relative">
      <div class="laptop-frame">
          <img src="@/assets/images/web_mock.png" />
      </div>
      <div class="laptop-body" style="font-family: inherit">
          <div
              class="header-mob"
              :style="` background: linear-gradient(180deg, ${statusBar} 0%, ${headerTop} 99.99%); color:${headerFont};`"
          >
              <div class="app-logo">
                  <img
                      src="@/assets/images/mob-default-img.svg"
                      v-if="!appIcon"
                  />
                  <img :src="appIcon" v-else />
                  <div class="app-name">{{ appName }}</div>
              </div>
              <div class="status-bar--2">
                  <div>
                      <img
                          src="@/assets/images/map-icon.svg"
                          alt=""
                          :style="headerIconStyle"
                      />Pune, Maharastra
                      <img
                          src="@/assets/images/down-arrow.svg"
                          :style="headerIconStyle"
                      />
                  </div>
              </div>
              <div class="abc">
                  <div class="parent">
                      <div class="product">Product</div>
                      <div class="store">Store</div>
                  </div>
              </div>

              <div class="filter-bar">
                  <div class="search-bar-large">
                      <img src="@/assets/images/search-icon.svg" />
                      Search For Products/Services
                  </div>
                  <div class="search-bar-small">
                      Any
                      <img
                          src="@/assets/images/down-arrow.svg"
                          style="float: right"
                      />
                  </div>
              </div>
              <div class="store-area-2">
                  <span>Available On</span>
                  <img src="@/assets/images/app-store.svg" />
              </div>
              <div class="account">
                  <img src="@/assets/images/shopping-cart.svg" alt="" />
                  <div class="name">Benjamin</div>
              </div>
          </div>
          <div class="body-mob">
              <div class="advertisement">
                  <img
                      src="@/assets/images/web-advertisement.png"
                      alt=""
                      class="sales-advertisement"
                  />
                  <div class="label-1">One App for all your needs!</div>
                  <div class="label-2">
                      Enjoy your Shopping with <span>{{ appName }}</span
                      >!
                  </div>
              </div>
              <b class="ml-4">Our Market</b>
              <img class="call" src="@/assets/images/call-icon.svg" alt="" />
              <img
                  class="scroll"
                  src="@/assets/images/icon-scroll.svg"
                  alt=""
              />
              <img
                  class="rightside"
                  src="@/assets/images/right-side-icon.svg"
                  alt=""
              />
              <img
                  class="leftside"
                  src="@/assets/images/right-side-icon.svg"
                  alt=""
              />
              <div
                  class="item-logos"
                  :style="`background:${primaryLightColor};`"
              >
                  <div class="item">
                      <img
                          src="@/assets/images/icon-electronics.svg"
                          alt=""
                      />
                      Electronics
                  </div>
                  <div class="item">
                      <img src="@/assets/images/icon-grocery.svg" alt="" />
                      Grocery
                  </div>
                  <div class="item">
                      <img src="@/assets/images/icon-pharmacy.svg" alt="" />
                      Pharmacy
                  </div>
                  <div class="item">
                      <img src="@/assets/images/icon-fashion.svg" alt="" />
                      Fashion
                  </div>
                  <div class="item">
                      <img src="@/assets/images/icon-healthcare.svg" alt="" />
                      Healthcare
                  </div>
                  <div class="item">
                      <img src="@/assets/images/icon-education.svg" alt="" />
                      Education
                  </div>
              </div>
              <div class="new-store-labels">
                  New Stores
                  <div class="search-bar-small-2">
                      Local
                      <img
                          src="@/assets/images/down-arrow.svg"
                          style="float: right; margin-top: 3px"
                      />
                  </div>
                  <span style="font-size: 10px"> All Stores &#10093;</span>
              </div>
              <div class="store-area">
                  <div class="store-item" v-for="(item, i) in 3" :key="i">
                      <img src="@/assets/images/store-item.svg" alt="" />
                      <div class="store-name">Store Name</div>
                      <div class="distance">5 KM</div>
                      <div class="rating">4</div>
                      <div class="location">Pune, Maharashtra</div>
                  </div>
              </div>
              <div class="m-4"></div>
              <div class="new-store-labels">
                  New Arrivals
                  <div class="search-bar-small-2" style="margin-left: 40px">
                      Ghatal
                      <img
                          src="@/assets/images/down-arrow.svg"
                          style="float: right; margin-top: 3px"
                      />
                  </div>
                  <span style="font-size: 10px"> More &#10093;</span>
              </div>
              <div class="store-area">
                  <div class="store-item" v-for="(item, i) in 3" :key="i">
                      <img src="@/assets/images/new-item.svg" alt="" />
                      <div class="discount">10%</div>
                  </div>
              </div>
          </div>
          <!-- Update the footer section in template -->
          <div
              class="mt-2"
              :style="`background-color: ${footerBgColor}; color: ${footerTextColor};`"
          >
              <div class="footer-content">
                  <div class="footer-section about-us">
                      <h3>About Us</h3>
                      <p>
                          Welcome to EPARISEVA where we share information
                          related...
                      </p>
                  </div>

                  <div class="footer-section">
                      <h3>My Account</h3>
                      <ul>
                          <li>My Account</li>
                          <li>Order History</li>
                          <li>Shopping cart</li>
                          <li>Wishlist</li>
                      </ul>
                  </div>

                  <div class="footer-section">
                      <h3>Helps</h3>
                      <ul>
                          <li>Contact</li>
                          <li>FAQs</li>
                          <li>Terms & Conditions</li>
                          <li>Privacy Policy</li>
                      </ul>
                  </div>

                  <div class="footer-section">
                      <h3>Proxy</h3>
                      <ul>
                          <li>About us</li>
                          <li>Shop</li>
                          <li>Product</li>
                          <li>Track Order</li>
                      </ul>
                  </div>
              </div>
              <hr class="my-0" />
              <div class="footer-bottom">
                  <p class="mb-0">
                      Copyright © 2025 epariseva All Rights Reserved.
                  </p>
                  <div class="payment-methods">
                      <img src="@/assets/images/card/visa.png" alt="Visa" />
                      <img
                          src="@/assets/images/card/master-card.png"
                          alt="Mastercard"
                      />
                      <img
                          src="@/assets/images/card/apple-pay.png"
                          alt="ApplePay"
                      />
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
// Note The icon need to be black for colour change to work

class Color {
  constructor(r, g, b) {
      this.set(r, g, b);
  }

  toString() {
      return `rgb(${Math.round(this.r)}, ${Math.round(this.g)}, ${Math.round(this.b)})`;
  }

  set(r, g, b) {
      this.r = this.clamp(r);
      this.g = this.clamp(g);
      this.b = this.clamp(b);
  }

  hueRotate(angle = 0) {
      angle = (angle / 180) * Math.PI;
      const sin = Math.sin(angle);
      const cos = Math.cos(angle);

      this.multiply([
          0.213 + cos * 0.787 - sin * 0.213,
          0.715 - cos * 0.715 - sin * 0.715,
          0.072 - cos * 0.072 + sin * 0.928,
          0.213 - cos * 0.213 + sin * 0.143,
          0.715 + cos * 0.285 + sin * 0.14,
          0.072 - cos * 0.072 - sin * 0.283,
          0.213 - cos * 0.213 - sin * 0.787,
          0.715 - cos * 0.715 + sin * 0.715,
          0.072 + cos * 0.928 + sin * 0.072,
      ]);
  }

  grayscale(value = 1) {
      this.multiply([
          0.2126 + 0.7874 * (1 - value),
          0.7152 - 0.7152 * (1 - value),
          0.0722 - 0.0722 * (1 - value),
          0.2126 - 0.2126 * (1 - value),
          0.7152 + 0.2848 * (1 - value),
          0.0722 - 0.0722 * (1 - value),
          0.2126 - 0.2126 * (1 - value),
          0.7152 - 0.7152 * (1 - value),
          0.0722 + 0.9278 * (1 - value),
      ]);
  }

  sepia(value = 1) {
      this.multiply([
          0.393 + 0.607 * (1 - value),
          0.769 - 0.769 * (1 - value),
          0.189 - 0.189 * (1 - value),
          0.349 - 0.349 * (1 - value),
          0.686 + 0.314 * (1 - value),
          0.168 - 0.168 * (1 - value),
          0.272 - 0.272 * (1 - value),
          0.534 - 0.534 * (1 - value),
          0.131 + 0.869 * (1 - value),
      ]);
  }

  saturate(value = 1) {
      this.multiply([
          0.213 + 0.787 * value,
          0.715 - 0.715 * value,
          0.072 - 0.072 * value,
          0.213 - 0.213 * value,
          0.715 + 0.285 * value,
          0.072 - 0.072 * value,
          0.213 - 0.213 * value,
          0.715 - 0.715 * value,
          0.072 + 0.928 * value,
      ]);
  }

  multiply(matrix) {
      const newR = this.clamp(
          this.r * matrix[0] + this.g * matrix[1] + this.b * matrix[2],
      );
      const newG = this.clamp(
          this.r * matrix[3] + this.g * matrix[4] + this.b * matrix[5],
      );
      const newB = this.clamp(
          this.r * matrix[6] + this.g * matrix[7] + this.b * matrix[8],
      );
      this.r = newR;
      this.g = newG;
      this.b = newB;
  }

  brightness(value = 1) {
      this.linear(value);
  }
  contrast(value = 1) {
      this.linear(value, -(0.5 * value) + 0.5);
  }

  linear(slope = 1, intercept = 0) {
      this.r = this.clamp(this.r * slope + intercept * 255);
      this.g = this.clamp(this.g * slope + intercept * 255);
      this.b = this.clamp(this.b * slope + intercept * 255);
  }

  invert(value = 1) {
      this.r = this.clamp((value + (this.r / 255) * (1 - 2 * value)) * 255);
      this.g = this.clamp((value + (this.g / 255) * (1 - 2 * value)) * 255);
      this.b = this.clamp((value + (this.b / 255) * (1 - 2 * value)) * 255);
  }

  hsl() {
      // Code taken from https://stackoverflow.com/a/9493060/2688027, licensed under CC BY-SA.
      const r = this.r / 255;
      const g = this.g / 255;
      const b = this.b / 255;
      const max = Math.max(r, g, b);
      const min = Math.min(r, g, b);
      let h,
          s,
          l = (max + min) / 2;

      if (max === min) {
          h = s = 0;
      } else {
          const d = max - min;
          s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
          switch (max) {
              case r:
                  h = (g - b) / d + (g < b ? 6 : 0);
                  break;

              case g:
                  h = (b - r) / d + 2;
                  break;

              case b:
                  h = (r - g) / d + 4;
                  break;
          }
          h /= 6;
      }

      return {
          h: h * 100,
          s: s * 100,
          l: l * 100,
      };
  }

  clamp(value) {
      if (value > 255) {
          value = 255;
      } else if (value < 0) {
          value = 0;
      }
      return value;
  }
}

class Solver {
  constructor(target, baseColor) {
      this.target = target;
      this.targetHSL = target.hsl();
      this.reusedColor = new Color(0, 0, 0);
  }

  solve() {
      const result = this.solveNarrow(this.solveWide());
      return {
          values: result.values,
          loss: result.loss,
          filter: this.css(result.values),
      };
  }

  solveWide() {
      const A = 5;
      const c = 15;
      const a = [60, 180, 18000, 600, 1.2, 1.2];

      let best = { loss: Infinity };
      for (let i = 0; best.loss > 25 && i < 3; i++) {
          const initial = [50, 20, 3750, 50, 100, 100];
          const result = this.spsa(A, a, c, initial, 1000);
          if (result.loss < best.loss) {
              best = result;
          }
      }
      return best;
  }

  solveNarrow(wide) {
      const A = wide.loss;
      const c = 2;
      const A1 = A + 1;
      const a = [0.25 * A1, 0.25 * A1, A1, 0.25 * A1, 0.2 * A1, 0.2 * A1];
      return this.spsa(A, a, c, wide.values, 500);
  }

  spsa(A, a, c, values, iters) {
      const alpha = 1;
      const gamma = 0.16666666666666666;

      let best = null;
      let bestLoss = Infinity;
      const deltas = new Array(6);
      const highArgs = new Array(6);
      const lowArgs = new Array(6);

      for (let k = 0; k < iters; k++) {
          const ck = c / Math.pow(k + 1, gamma);
          for (let i = 0; i < 6; i++) {
              deltas[i] = Math.random() > 0.5 ? 1 : -1;
              highArgs[i] = values[i] + ck * deltas[i];
              lowArgs[i] = values[i] - ck * deltas[i];
          }

          const lossDiff = this.loss(highArgs) - this.loss(lowArgs);
          for (let i = 0; i < 6; i++) {
              const g = (lossDiff / (2 * ck)) * deltas[i];
              const ak = a[i] / Math.pow(A + k + 1, alpha);
              values[i] = fix(values[i] - ak * g, i);
          }

          const loss = this.loss(values);
          if (loss < bestLoss) {
              best = values.slice(0);
              bestLoss = loss;
          }
      }
      return { values: best, loss: bestLoss };

      function fix(value, idx) {
          let max = 100;
          if (idx === 2 /* saturate */) {
              max = 7500;
          } else if (idx === 4 /* brightness */ || idx === 5 /* contrast */) {
              max = 200;
          }

          if (idx === 3 /* hue-rotate */) {
              if (value > max) {
                  value %= max;
              } else if (value < 0) {
                  value = max + (value % max);
              }
          } else if (value < 0) {
              value = 0;
          } else if (value > max) {
              value = max;
          }
          return value;
      }
  }

  loss(filters) {
      // Argument is array of percentages.
      const color = this.reusedColor;
      color.set(0, 0, 0);

      color.invert(filters[0] / 100);
      color.sepia(filters[1] / 100);
      color.saturate(filters[2] / 100);
      color.hueRotate(filters[3] * 3.6);
      color.brightness(filters[4] / 100);
      color.contrast(filters[5] / 100);

      const colorHSL = color.hsl();
      return (
          Math.abs(color.r - this.target.r) +
          Math.abs(color.g - this.target.g) +
          Math.abs(color.b - this.target.b) +
          Math.abs(colorHSL.h - this.targetHSL.h) +
          Math.abs(colorHSL.s - this.targetHSL.s) +
          Math.abs(colorHSL.l - this.targetHSL.l)
      );
  }

  css(filters) {
      function fmt(idx, multiplier = 1) {
          return Math.round(filters[idx] * multiplier);
      }
      return `filter: invert(${fmt(0)}%) sepia(${fmt(1)}%) saturate(${fmt(
          2,
      )}%) hue-rotate(${fmt(3, 3.6)}deg) brightness(${fmt(4)}%) contrast(${fmt(5)}%);`;
  }
}

export default {
  props: {
      font: {
          type: String,
          default: "",
      },
      primaryColor: {
          type: String,
          default: "#ffffff",
      },
      primaryLightColor: {
          type: String,
          default: "#ffffff",
      },
      statusBar: {
          type: String,
          default: "#ffffff",
      },
      headerTop: {
          type: String,
          default: "#ffffff",
      },
      headerBottom: {
          type: String,
          default: "#ffffff",
      },
      headerFont: {
          type: String,
          default: "#ffffff",
      },
      footerBgColor: {
          type: String,
          default: "#ffffff",
      },
      footerTextColor: {
          type: String,
          default: "#ffffff",
      },
      appIcon: {
          type: String,
          default: null,
      },

      appName: {
          type: String,
          default: "App Name",
      },
  },
  methods: {
      hexToRgb(hex) {
          // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
          const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
          hex = hex.replace(shorthandRegex, (m, r, g, b) => {
              return r + r + g + g + b + b;
          });

          const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
              hex,
          );
          return result
              ? [
                    parseInt(result[1], 16),
                    parseInt(result[2], 16),
                    parseInt(result[3], 16),
                ]
              : null;
      },
      changeToColor(col) {
          const rgb = this.hexToRgb(col);

          const color = new Color(rgb[0], rgb[1], rgb[2]);
          const solver = new Solver(color);
          const result = solver.solve();
          return result.filter;
      },
  },
  computed: {
      headerIconStyle() {
          return this.changeToColor(this.headerFont);
      },
      // footerNormalStyle() {
      //   return this.changeToColor(this.footerNormal);
      // },
      // footerSelStyle() {
      //   return this.changeToColor(this.footerSelection);
      // },
      splashBGStyle() {
          if (this.splashBGImage) {
              return `background-image:url(${this.splashBGImage});background-color:${this.splashBGCol};`;
          }
          return `background:${this.splashBGCol};`;
      },
  },
  mounted() {
      this.changeToColor("#aa44bb");
  },
};
</script>

<style lang="scss" scoped>
.laptop-body {
width: 500px;
height: 290px;
background: #ffffff;
position: absolute;
top: 0;
left: 50%;
transform: translateX(-50%);
z-index: 1;
font-size: 10px;
overflow-y: auto;
overflow-x: hidden;
}

.body-mob {
  background: #f5f5f5;
  padding-bottom: 24px;
}

.header-mob {
  width: 100%;
  height: 45px;
  border-radius: 0;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0px 2.2637px 5.65925px rgba(0, 0, 0, 0.15);
}

.status-bar {
  display: flex;
  justify-content: space-between;
  padding: 6px 10px;

  font-size: 8px;
  font-weight: 550;
}

.status-bar--2 {
  display: flex;
  justify-content: space-between;
  padding: 6px 10px;

  font-size: 6px;
  font-weight: 300;

  img {
      width: 10px;
  }
}

.filter-bar {
  margin: 5px 10px;
  color: #979797;
  font-size: 6px;
}

.search-bar-large {
  width: 120px;
  padding: 2px 5px;
  background: white;
  vertical-align: middle;
  border-radius: 10px;
  display: inline-block;
}

.search-bar-small {
  width: 40px;
  padding: 4px 5px;
  background: white;
  vertical-align: middle;
  border-radius: 10px;
  display: inline-block;
  margin-left: 6px;
}

.search-bar-small-2 {
  width: 25%;
  padding: 4px 5px;
  background: white;
  vertical-align: middle;
  border-radius: 10px;
  display: inline-block;
  margin-left: 6px;
  color: #979797;
  border: 1px solid #dfdfdf;
}

.change-my-color {
  fill: green;
}

.sales-advertisement {
  margin: 8px auto;
  display: block;
  height: 130px;
}

img.sales-advertisement {
  width: 100%;
}

.item-logos {
  display: flex;
  padding: 12px 24px;
  margin: 10px auto;
  max-width: 1120px;
  border-radius: 8px;

  .item {
      img {
          height: 45px;
      }

      display: flex;
      margin: 0 9px;
      font-size: 7.5px;
      flex-direction: column;
      align-items: center;
  }
}

.new-store-labels {
  font-size: 12px;
  font-weight: 600;
  color: #000;
  padding: 0 12px;
  margin-top: 20px;
}

.search-bar-small-2 {
  width: 25%;
  padding: 2px 5px;
  margin-left: 40px;
  background: white;
  vertical-align: middle;
  border-radius: 2.26px;
  display: inline-block;
  font-size: 8px;
  color: #979797;
  border: 1px solid #dfdfdf;
  margin-right: 10px;
}

.store-area {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 24px 0;

  .store-item {
      position: relative;
      flex: 1 1 calc(25% - 12px);
      max-width: calc(25% - 12px);

      img {
          width: 100%;
          height: auto;
          display: block;
          border-radius: 8px;
      }

      .store-name {
          position: absolute;
          z-index: 1;
          font-size: 7.5px;
          color: rgb(252, 252, 252);
          bottom: 24px;
          left: 6px;
          font-weight: 500;
      }

      .distance {
          position: absolute;
          z-index: 1;
          font-size: 7.5px;
          color: black;
          bottom: 9px;
          left: 16px;
          font-weight: 520;
      }

      .rating {
          position: absolute;
          z-index: 1;
          font-size: 7.5px;
          color: black;
          bottom: 9px;
          right: 0px;
          font-weight: 520;
      }

      .location {
          position: absolute;
          z-index: 1;
          font-size: 7.5px;
          color: black;
          bottom: -2px;
          left: 8px;
          font-weight: 500;
      }

      .discount {
          position: absolute;
          z-index: 1;
          font-size: 7.5px;
          color: rgb(255, 255, 255);
          top: 5px;
          left: 8px;
          font-weight: 500;
      }
  }
}

.laptop-frame {
  position: relative;
  width: 725px;
  margin: 0 auto;
  padding-top: 0;
  z-index: 10;
  pointer-events: none; /* let scroll & clicks go to laptop-body */

  img {
    display: block;
    width: 100%;
    height: auto;
    object-fit: contain;
    pointer-events: none;
  }
}

.app-logo {
  font-size: 8px;

  img {
      width: 25px;
  }
}

.advertisement {
  position: relative;
}

.label-1 {
  position: absolute;
  top: 15px;
  z-index: 2;
  color: #0b4990;
  font-size: 20px;
  right: 15px;
  font-weight: 600;
}

.label-2 {
  position: absolute;
  top: 42px;
  z-index: 2;
  color: #0b4990;
  font-size: 12px;
  right: 15px;
  font-weight: 500;

  span {
      color: #fe7b08;
  }
}

.call {
  position: absolute;
  right: 15px;
  top: 189px;
}

.scroll {
  position: absolute;
  right: 15px;
  top: 209px;
}

.rightside {
  position: absolute;
  right: 26px;
  top: 240px;
}

.leftside {
  position: absolute;
  left: 26px;
  top: 240px;
  transform: rotateZ(180deg);
}

.abc {
  position: relative;

  .parent {
      position: relative;
      border: 1px solid white;
      padding: 0.5px;
      border-radius: 0.5px;
      display: flex;
  }

  .product {
      font-style: normal;
      font-weight: 600;
      font-size: 4.0371px;
      line-height: 6px;
      padding: 3px 6px;
      background: #ffffff;
      color: #2a8750;
      border-radius: 1px;
  }

  /* identical to box height */

  /* Store */
  .store {
      font-style: normal;
      padding: 3px 6px;
      font-weight: 400;
      font-size: 4.0371px;
      line-height: 6px;
      color: #ffffff;
  }

  /* identical to box height */
}

.store-area-2 {
  font-size: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
      width: 30px;
  }
}

.account {
  position: relative;

  .name {
      position: absolute;
      left: 8px;
      font-size: 6px;
      top: 4px;
  }
}

.laptop-body::-webkit-scrollbar {
  width: 6px;
}

.laptop-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.laptop-body::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.laptop-body::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
}

.footer-section h3 {
  font-size: 11px;
}

.about-us {
  width: 100px;
}

.footer-section ul {
  padding-left: 0;
  list-style: none;
}
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  padding-bottom: 12px;
  padding-top: 12px;
}
.payment-methods {
  display: flex;
  gap: 10px;
}
.payment-methods img {
  height: 100%;
  width: 40px;
}

/* Responsive layout for laptop / tablet / mobile */
@media (max-width: 1024px) {
  .store-area .store-item {
      flex: 1 1 calc(33.333% - 12px);
      max-width: calc(33.333% - 12px);
  }

  .item-logos {
      flex-wrap: wrap;
      justify-content: center;
  }
}

@media (max-width: 768px) {
  .header-mob {
      flex-wrap: wrap;
      height: auto;
      padding: 8px 10px;
  }

  .store-area .store-item {
      flex: 1 1 calc(50% - 12px);
      max-width: calc(50% - 12px);
  }

  .footer-content {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
  }

  .footer-bottom {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
  }
}

@media (max-width: 480px) {
  .item-logos {
      padding: 8px 12px;
  }

  .new-store-labels {
      padding: 0 12px;
  }

  .search-bar-large {
      width: 100px;
  }
}
</style>
